import { Link, useMatch } from 'react-router';
import { useTranslation } from 'react-i18next';
import Button from 'shared/Button';
import { SITE_ROUTE_PATH } from 'utils/constants';
import { useAuthContext } from 'utils/contexts/AuthContext';
import FourOhFour from './404.svg?react';
import NoSites from './NoSites.svg?react';
import { useSitesCount } from 'utils/hooks/useSitesCount';

export const NotFound = () => {
    const { t } = useTranslation('not_found');

    const siteRouteMatch = useMatch(SITE_ROUTE_PATH);

    const { account } = useAuthContext();

    const totalSitesCount = useSitesCount();

    const isSiteRoute = !!siteRouteMatch;
    const isUserDisabled =
        (account?.proxy_user?.role || account?.role) === 'Disabled';
    const noSites = isSiteRoute && !totalSitesCount;

    return (
        <div className="flex flex-col gap-4 h-full items-center justify-center overflow-hidden">
            {noSites ? <NoSites /> : <FourOhFour />}

            <h1 className="font-bold text-6xl/tight text-center text-gray-700">
                {t(`${noSites ? 'no_sites' : 'default'}.title`)}
            </h1>

            <h2 className="max-w-[500px] text-base text-center text-gray-700">
                {t(`${isUserDisabled ? 'user_disabled' : 'default'}.subtitle`)}
            </h2>

            <Button as={Link} size="sm" to="/">
                {t('default.home_button')}
            </Button>
        </div>
    );
};
